import { Controller } from "@hotwired/stimulus"

import { trackStripeCheckoutOpened } from "@/lib/posthog"

// Emits the "checkout intent" funnel event for a buy button that submits its
// form natively.
//
// The hero CTA on a paid container sits *outside* the unlock controller's
// scope, so it reaches the hidden purchase form through the native `form=`
// association rather than through unlock#handleUnlock. That keeps it working
// (and keeps it working without JS), but handleUnlock is the only caller of
// trackStripeCheckoutOpened — so the most prominent buy button on the page was
// starting checkouts the funnel never saw, including ones that then failed at
// Stripe session creation.
//
// Deliberately does not preventDefault or submit anything: the native submit
// is the behaviour, this only observes it. Raised by Codex review on
// https://github.com/Indee/indee-rails/pull/1681.
export default class extends Controller {
  static values = { paymentType: { type: String, default: "purchase" } }

  declare paymentTypeValue: string

  track(): void {
    trackStripeCheckoutOpened(this.paymentTypeValue)
  }
}
